import React from 'react';
import { connect } from 'react-redux';

import { signup, reset } from '../../../../redux/auth/signup/actions';

import SignupModal from './SignupModal';

import { selectIsLoading, selectError, selectErrorMessage } from './selectors';

const SignupModalConnected = (props) => <SignupModal {...props} />;

const mapDispatchToProps = (state) => ({
  isLoading: selectIsLoading(state),
  error: selectError(state),
  errorMessage: selectErrorMessage(state),
});

const mapActionsToProps = {
  signup,
  reset,
};

export default connect(mapDispatchToProps, mapActionsToProps)(SignupModalConnected);
